import * as React from "react";
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";
import Alert, { AlertCategoryEnum } from "../misc/components/Alert";

export const NotificationSettings = () => {
    const [dailySummaryExpression, setDailySummaryExpression] = React.useState<string>("");
    const legacyClient = useWebPortalLegacyClient();
    const [error, setError] = React.useState<string | undefined>();
    const [saved, setSaved] = React.useState<boolean>(false);
    const settingKey = "Vitalograph.WebPortal.Data.Settings.NotificationDailySummaryTimeSetting";

    React.useEffect(() => {
        const getSetting = async () => {
            const result = await legacyClient.getNotificationSettings();
            setDailySummaryExpression(result.dailySummaryTime);
        }

        getSetting();
    }, []);

    const onSave = async () => {
        try {
            setSaved(false);
            setError(undefined);
            await legacyClient.putSetting(settingKey, dailySummaryExpression);
            setSaved(true);
        } catch (ex) {
            setError(ex.Message);
        }
    }

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <h3 className="text-primary">Settings</h3>
                </div>
            </div>
        <div className="panel panel-default">
                <div className="panel-body">
                    <Alert category={AlertCategoryEnum.Danger} show={error !== undefined}>{error}</Alert>
                    <Alert category={AlertCategoryEnum.Success} show={saved}>Saved Successfully</Alert>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="dailySummaryExpression">Unread Notifications Cron Expression</label>
                                <input id="dailySummaryExpression" className="form-control" value={dailySummaryExpression} onChange={(e) => setDailySummaryExpression(e.target.value)} type="text" />
                            </div>
                            <div className="form-group">
                                <button type="button" className="btn btn-primary" onClick={() => onSave()}>Save Schedule</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
